import { useSuspenseStatsigClient } from './useSuspenseStatsigClient';

export function useSuspenseFeatureGate(gateName: string) {
    const { checkGate } = useSuspenseStatsigClient();

    return checkGate(gateName);
}
